<template>
  <v-navigation-drawer absolute class="nav">
    <v-list class="nav">
      <v-list-group repend-icon="account_circle" value="true">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Configuration Module</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-group no-action sub-group>
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Device Level</v-list-tile-title>
            </v-list-tile>
          </template>

          <v-list-tile v-for="(admin, i) in admins" :key="i" >
            <v-list-tile-title v-text="admin[0]" class="side-component"></v-list-tile-title>
            <v-list-tile-action>
              <v-icon v-text="admin[1]"></v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

        <v-list-group sub-group no-action value="true">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Component Level</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="(crud, i) in cruds" :key="i">
            <v-list-tile-title v-text="crud[0]['name']" @click="() => navigate(crud[0]['path'])" class="side-component"></v-list-tile-title>
          </v-list-tile>
        </v-list-group>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    data() {
      return {
        admins: [
        ['xyz'],
        ['abc']
      ],
      cruds: [
        [{ 'name': 'Custom Report Config', 'path': 'icsReportConfig' }],
        [{ 'name': 'Analytic Device Config', 'path': 'icsAnalyticsConfig'}],
        [{ 'name': 'Plant Detail Config', 'path': 'icsPlantConfig'}]
      ]
      }
    },
    methods: {
      navigate(path) {
        this.$router.push({ 'name': path })
      }
    }
  }
</script>

<style scoped>
.side-component{
  cursor: pointer;
}
</style>